module.exports = "84b4cee97dc9855734eabfe49f60c4a6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/cursor_normal.png
// module id = 108
// module chunks = 0